'use client'

import { useMemo } from 'react'
import {
  buildShapeOptionsFromProjects,
  withDynamicPropertyOptions,
} from '@/hooks/gridOptionLookups'
import { useGridOptions } from '@/hooks/useGridOptions'
import type { Language } from '@/types/translations'

export const useOptions = ({
  propertyOptionsLang,
}: {
  propertyOptionsLang?: Language
} = {}) => {
  const gridOptions = useGridOptions({ propertyOptionsLang })
  const { allProjects = [], projectID: projects = [] } = gridOptions

  const shapeID = useMemo(
    () => buildShapeOptionsFromProjects(allProjects),
    [allProjects],
  )
  const projectID = useMemo(
    () =>
      projects.map((project) => ({
        ...project,
        id: String(project.value),
        value: String(project.value),
        isSelectable: !project.disabled,
      })),
    [projects],
  )

  return useMemo(() => {
    return withDynamicPropertyOptions(
      withDynamicPropertyOptions(gridOptions, 'projectID', projectID),
      'shapeID',
      shapeID,
    )
  }, [gridOptions, projectID, shapeID])
}
